import { StatutActivite } from '@/enum/AAT.enum';

export class CategorieSocialePatient implements CategorieSocialePatientState {
	categorie: string;
	categorieDetail: string;

	constructor(
		categorie: string = StatutActivite.SALARIE,
		categorieDetail: string = ''
	) {
		this.categorie = categorie;
		this.categorieDetail = categorieDetail;
	}
}

export interface CategorieSocialePatientState {
	categorie: string;
	categorieDetail: string;
}
